import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";

import { useAuth } from "context/UserContext";
import { useLocation, useNavigate } from "react-router-dom";
import { getReviewAllDispute } from "api/ReviewService";

import DisputeComponent from "./DisputeComponent";
import IMAGES from "constants/images";
import { Sentry } from "react-activity";
import Loader from "components/Loader";
// const RatingStars = ({ rating }) => {
//   const stars = [];
//   for (let i = 1; i <= 5; i++) {
//     stars.push(
//       <span
//         key={i}
//         style={{
//           color: i <= rating ? "#E91515" : "#ccc",
//           fontSize: "1.2rem",
//           marginRight: "4px",
//         }}
//       >
//         ★
//       </span>
//     );
//   }
//   return <span>{stars}</span>;
// };

const Disputes = () => {
  const navigate=useNavigate()
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [uiLoading, setUiLoading] = useState(true);
  const limit = 10;
  const location = useLocation();
  const productId = location?.state?.productId || "";
  const title=location?.state?.title
  const slug=location?.state?.slug
  const { user } = useAuth();
  const userId = user ? user._id : "";
  const fetchDispute = async () => {
    try {
      if(!productId){
       return navigate(`/`)
      }
      const res = await getReviewAllDispute({ productId, limit, page }); // API call
      if (res.success) {
        setData(res.body.data);
      }
      setUiLoading(false)
    } catch (error) {
      setUiLoading(false)
      console.error("Error fetching reviews:", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchDispute();
  }, [page]);

  if(uiLoading){
    return (<div
      className="d-flex justify-content-center align-items-center "
      style={{ minHeight: "50vh" }}
    >
      <Sentry color="#e91515" size={40} speed={1} animating={true} />
      {/* <Loader style={{width: 100, height: 100}}/> */}
    </div>)
      }

  return (
    <React.Fragment>
      {/* BreadCrumb Section */}
      <BreadcrumbSection
        breadcrumbs={[
          {
            title: title,
            link: `/product-details/${slug}`,
          },
          { title: "Disputes" }, // Active breadcrumb (no link)
        ]}
      />
      <section className="software_section py-5">
        <Container>
          <Row className="mb-4">
            <Col lg={12}>
              <div className="software_header mb-3">
                <h2>Disputes</h2>
              </div>
              {data?.length > 0 ? (
                data?.map((dispute, index) => {
                  return (
                   <DisputeComponent key={dispute?._id} dispute={dispute} userId={userId} fetchData={()=>fetchDispute()} />
                  );
                })
              ) : (
                <Col xs={12}>
                <div className="text-center py-5">
                  <Image
                    src={IMAGES.emptyState}
                    alt=""
                      height="300px"
                    width= "300px"
                    className="mb-4"
                    // className="imgUser"
                  />
                <p className="text-center text-muted">No dispute found.</p>
                </div>
                </Col>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default Disputes;
